let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jpjSn")).then(() => parcelRequire('fyBKV'));